import { createTranslator, type Translator } from 'schummar-translate/react';

export type TranslationFormatter<T> = Pick<Translator<any, any, any, T>, `${string}Format` & keyof Translator<any, any, any, T>>;

export const { t, useTranslator, getTranslator, TranslationContextProvider, useGetTranslator } = createTranslator({
  sourceLocale: 'en',
  sourceDictionary: {},
});
